import { EVENT_MAP } from "@/lib/events";

export const CardButtons = ({ onPick, testPrefix }) => (
  <div className="grid grid-cols-2 gap-2">
    {["amarelo", "vermelho"].map((k) => (
      <button key={k} data-testid={`${testPrefix}-${k}`} onClick={() => onPick(k)}
        style={{ background: EVENT_MAP[k].color, color: EVENT_MAP[k].text }}
        className="tap h-14 font-display text-lg font-bold uppercase hover:brightness-110">
        {EVENT_MAP[k].label}
      </button>
    ))}
  </div>
);
